import React from 'react';
import YouthSportsHero from '../../components/YouthSportsHero/YouthSportsHero';
import YouthPrograms from '../../components/YouthPrograms/YouthPrograms';
import SportsDevelopment from '../../components/SportsDevelopment/SportsDevelopment';
import SportsAchievements from '../../components/SportsAchievements/SportsAchievements';

const YouthSports = () => {
  return (
    <div>
      <YouthSportsHero />
      <YouthPrograms />
      <SportsDevelopment />
      <SportsAchievements />
    </div>
  );
};

export default YouthSports;